(function(){
  function setMode(m){
    document.body.classList.toggle('tdgs-train', m==='train');
    try{sessionStorage.setItem('tdgs_mode',m);}catch(e){}
    document.querySelectorAll('.tdgs-toggle button').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-mode')===(m==='train'?'train':'shop'));
    });
  }
  window.tdgsSetMode=function(m,scroll){
    setMode(m);
    if(scroll!==false){var h=document.querySelector('.tdgs-modebar')||document.querySelector('.tdgs-hero');if(h)h.scrollIntoView({behavior:'smooth'});}
  };
  document.addEventListener('DOMContentLoaded',function(){
    var m='shop';try{m=sessionStorage.getItem('tdgs_mode')||'shop';}catch(e){}
    var trainAnchors=['#tdgs-courses','#tdgs-seminars','#tdgs-trainer'];
    if(trainAnchors.indexOf(location.hash)>-1){m='train';}
    else if(location.hash==='#tdgs-categories'||location.hash==='#tdgs-bestsellers'||location.hash==='#tdgs-brands'||location.hash==='#tdgs-trade'){m='shop';}
    setMode(m);
    if(location.hash){var t=document.querySelector(location.hash);if(t){setTimeout(function(){t.scrollIntoView({behavior:'smooth'});},150);}}
    document.querySelectorAll('[data-tdgs-mode]').forEach(function(el){
      el.addEventListener('click',function(ev){ev.preventDefault();window.tdgsSetMode(el.getAttribute('data-tdgs-mode'));});
    });
    window.addEventListener('hashchange',function(){
      if(trainAnchors.indexOf(location.hash)>-1){setMode('train');var t=document.querySelector(location.hash);if(t)t.scrollIntoView({behavior:'smooth'});}
    });
  });
})();
